/**
 * 兜底页顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"

export function DefaultBasicInfo() {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
            <div>
              <p className="stock-value">{single_quote[quote_item_name.最新价](store.StockDetail).element}</p>
              <p>
                {single_quote[quote_item_name.涨跌幅](store.StockDetail).element} &nbsp;&nbsp;
                {single_quote[quote_item_name.涨跌额](store.StockDetail).element}
              </p>
            </div>
            <div>
              <div className="row">
                <>
                  <p>
                    <span>今开</span>
                    {single_quote[quote_item_name.今开](store.StockDetail).element}
                  </p>
                  <p>
                    <span>最高</span>
                    {single_quote[quote_item_name.最高](store.StockDetail).element}
                  </p>
                  <p>
                    <span>最低</span>
                    {single_quote[quote_item_name.最低](store.StockDetail).element}
                  </p>
                </>
              </div>
              <div className="row">
                <>
                  <p>
                    <span>换手</span>
                    {single_quote[quote_item_name.换手](store.StockDetail).element}
                  </p>
                  <p>
                    <span>总手</span>
                    {single_quote[quote_item_name.总手](store.StockDetail).element}
                  </p>
                  <p>
                    <span>金额</span>
                    {single_quote[quote_item_name.成交额](store.StockDetail).element}
                  </p>
                </>
              </div>
            </div>
          </div>
        </div>
      )}
    </Observer>
  )
}
